/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

export const BreadcrumbsBox = styled(Box)(({theme}) => ({
  margin: theme.spacing(4, 0, 8, 0),
}));

export const TableContainer = styled(Box)(({theme}) => ({
  margin: theme.spacing(6, 0, 8, 0),
}));
